import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Bin({ idVariant = '', className }: Props) {
  return (
    <IconBase name="bin" w={24} className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.5 2.5H16.5V6H22V7H19.5V21.5H4.5V7H2V6H7.5V2.5ZM5.5 7V20.5H18.5V7H5.5ZM15.5 3.5V6H8.5V3.5H15.5Z" fill="currentColor"/>
    </IconBase>
  )
}

export default Bin
